<template>
  <span
    class="pay-plan-period-state-badge"
    :class="[
      `pay-plan-period-state-badge--${normalized}`,
      filled ? 'pay-plan-period-state-badge--filled' : 'pay-plan-period-state-badge--outline',
    ]"
  >
    <span class="pay-plan-period-state-badge__dot" aria-hidden="true" />
    {{ label }}
  </span>
</template>

<script setup>
import { computed } from "vue";
import { normalizePayPlanPeriodState } from "@components/PayPlanRowCard/payPlanRowCardUtils";

const props = defineProps({
  state: {
    type: String,
    required: true,
  },
  /** Filled pills on Proposed rows; outline + dot on committed rows. */
  filled: {
    type: Boolean,
    default: false,
  },
});

const normalized = computed(() => normalizePayPlanPeriodState(props.state));

const label = computed(() => {
  switch (normalized.value) {
    case "future":
      return "Future";
    case "current":
      return "Current";
    case "lapsed":
      return "Lapsed";
    default:
      return "";
  }
});
</script>

<style scoped>
.pay-plan-period-state-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 2px 8px 2px 6px;
  border-radius: 9999px;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
}

.pay-plan-period-state-badge__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.pay-plan-period-state-badge--outline.pay-plan-period-state-badge--future {
  border: 1.5px solid #1570ef;
  color: #175cd3;
}

.pay-plan-period-state-badge--outline.pay-plan-period-state-badge--future
  .pay-plan-period-state-badge__dot {
  background: #2e90fa;
}

.pay-plan-period-state-badge--outline.pay-plan-period-state-badge--current {
  border: 1.5px solid #079455;
  color: #067647;
}

.pay-plan-period-state-badge--outline.pay-plan-period-state-badge--current
  .pay-plan-period-state-badge__dot {
  background: #17b26a;
}

.pay-plan-period-state-badge--outline.pay-plan-period-state-badge--lapsed {
  border: 1.5px solid #475467;
  color: #344054;
}

.pay-plan-period-state-badge--outline.pay-plan-period-state-badge--lapsed
  .pay-plan-period-state-badge__dot {
  background: #667085;
}

.pay-plan-period-state-badge--filled.pay-plan-period-state-badge--future {
  border: 1px solid #b2ddff;
  background: #eff8ff;
  color: #175cd3;
}

.pay-plan-period-state-badge--filled.pay-plan-period-state-badge--future
  .pay-plan-period-state-badge__dot {
  background: #2e90fa;
}

.pay-plan-period-state-badge--filled.pay-plan-period-state-badge--current {
  border: 1px solid #75e0a7;
  background: #dcfae6;
  color: #067647;
}

.pay-plan-period-state-badge--filled.pay-plan-period-state-badge--current
  .pay-plan-period-state-badge__dot {
  background: #17b26a;
}

.pay-plan-period-state-badge--filled.pay-plan-period-state-badge--lapsed {
  border: 1px solid #d0d5dd;
  background: #f2f4f7;
  color: #344054;
}

.pay-plan-period-state-badge--filled.pay-plan-period-state-badge--lapsed
  .pay-plan-period-state-badge__dot {
  background: #667085;
}
</style>
